(function() {
	'use strict';

	angular.module('hotransferApp').controller('HoTransferController',
			HoTransferController);

	HoTransferController.$inject = [ '$scope', '$state', '$stateParams',
			'$base64','CONST_EXPORTS', '$window', 'HoTransferService','CommonService',
			'$http', '$log', 'Upload', 'AlertService','EVENT',
			'authExpiredInterceptor', '$uibModal','NgTableParams' ];

	function HoTransferController($scope, $state, $stateParams, $base64,CONST_EXPORTS, $window, HoTransferService,CommonService, $http, $log, Upload,
			AlertService,EVENT, authExpiredInterceptor, $uibModal,NgTableParams) {
		var transferCtr = this;
		var param = $stateParams;
		$scope.loading = false;
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if(event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {reload: true});
			}
		});
		transferCtr.CONST_EXPORTS=CONST_EXPORTS;
		var pageIndex=0;
		if($stateParams.paramSearch!=undefined){
			var paramSearch=$base64.decode($stateParams.paramSearch);
		}
		var paramStatus=transferCtr.CONST_EXPORTS.VALUE_NULL;
		var paramCreatedDate=transferCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransfer=transferCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockRequest=transferCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransferCode=transferCtr.CONST_EXPORTS.VALUE_NULL;
		if(paramSearch!=undefined){
			var splitted = paramSearch.split(transferCtr.CONST_EXPORTS.SIGN_SEMICOLON);
			for(var i=0;i<splitted.length;i++){
				var paramSpit=splitted[i].split(transferCtr.CONST_EXPORTS.SIGN_COLON);
				if(paramSpit[0]==transferCtr.CONST_EXPORTS.PARAM_STATUS&&paramSpit[1]!=transferCtr.CONST_EXPORTS.VALUE_NULL){
					paramStatus=paramSpit[1];
				}
				if(paramSpit[0]==transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE&&paramSpit[1]!=transferCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockTransferCode=paramSpit[1];
				}
				if(paramSpit[0]==transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE&&paramSpit[1]!=transferCtr.CONST_EXPORTS.VALUE_NULL){
					paramCreatedDate=new Date(paramSpit[1]);
				}
				if(paramSpit[0]==transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST&&paramSpit[1]!=transferCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockRequest=paramSpit[1];
				}
				if(paramSpit[0]==transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER&&paramSpit[1]!=transferCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockTransfer=paramSpit[1];
				}
			}
		}
		transferCtr.dateOptions = {
			maxDate : new Date()
		};
		transferCtr.getItemArray = function(array, code) {
			if (code == null || code == undefined || code == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.statusCode === code;
				});
				return obj[0].statusName;
			} catch (e) {

			}			
		};
		transferCtr.getItemStockArray = function(array, stockId) {
			if (stockId == null || stockId == undefined || stockId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.stockId === stockId;
				});
				return obj[0].stockName;
			} catch (e) {

			}			
		};
		transferCtr.getItemStockIdArray = function(array, stockId) {
			if (stockId == null || stockId == undefined || stockId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.stockId === stockId;
				});
				return obj[0].stockId;
			} catch (e) {

			}			
		};
		transferCtr.find=function(){
			if (param.typeMenu == transferCtr.CONST_EXPORTS.CREATE_STATUS_VIEW) {
				transferCtr.tableParams = new NgTableParams({
					page: 1, // show first page
					count : 5,
					sorting: { 'stock_transfer_code': 'asc' } 
				// count per page
				}, {
//					filterDelay : 300,
//					total: transferAll[0].totalCount,
					total: 0,
					defaultSort: 'asc',
					getData: function(params) {
			    		var param = {};
			    		transferCtr.transferRequestDTO.page = params.page();
			    		transferCtr.transferRequestDTO.size = params.count();
			    		transferCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
			    		return HoTransferService.postPage({
							uri : 'getAllRequest'
						},transferCtr.transferRequestDTO).$promise.then(function(result) {
			    			params.total(result.totalElements);
			    			transferCtr.lengthSearch = result.totalElements;
							return result.content;;
						});
					 }
				});
			}else{
				transferCtr.tableParams = new NgTableParams({
					page: 1, // show first page
					count : 5,
					sorting: { 'stock_transfer_code': 'asc' } 
				// count per page
				}, {
//					filterDelay : 300,
//					total: transferAll[0].totalCount,
					total: 0,
					defaultSort: 'asc',
					getData: function(params) {
			    		var param = {};
			    		transferCtr.transferRequestDTO.page = params.page();
			    		transferCtr.transferRequestDTO.size = params.count();
			    		transferCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
			    		return HoTransferService.postPage({
							uri : 'getAllRequestApprove'
						},transferCtr.transferRequestDTO).$promise.then(function(result) {
			    			params.total(result.totalElements);
			    			transferCtr.lengthSearch = result.totalElements;
							return result.content;;
						});
					 }
				});
			}
		}
		if (param.typeMenu ==  transferCtr.CONST_EXPORTS.CREATE_STATUS_VIEW) {
			HoTransferService.query({
				uri : 'getAllStock'}).$promise.then(function(result){
					if (result) {
						transferCtr.transferRequestDTO={stockRequestLst:result,createdDate:paramCreatedDate
								,status:paramStatus,stockTransferId:transferCtr.getItemStockIdArray(result,parseInt(paramStockTransfer)),
								stockRequestId:transferCtr.getItemStockIdArray(result,parseInt(paramStockRequest)),stockTransferCode:paramStockTransferCode,
								page:1,size:5,sorting:'stock_transfer_code: "asc"'};
						transferCtr.createFlag = true;
						transferCtr.approveFlag = false;
						HoTransferService.query({
							uri : 'getAllStatus'
						}, function(result) {
							transferCtr.statusLst = result;
							transferCtr.tableParams = new NgTableParams({
								page: 1, // show first page
								count : 5,
								sorting: { 'stock_transfer_code': 'asc' } 
							// count per page
							}, {
//								filterDelay : 300,
//								total: transferAll[0].totalCount,
								total: 0,
								defaultSort: 'asc',
								getData: function(params) {
						    		var param = {};
						    		transferCtr.transferRequestDTO.page = params.page();
						    		transferCtr.transferRequestDTO.size = params.count();
						    		transferCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
						    		return HoTransferService.postPage({
										uri : 'getAllRequest'
									},transferCtr.transferRequestDTO).$promise.then(function(result) {
						    			params.total(result.totalElements);
						    			transferCtr.lengthSearch = result.totalElements;
										return result.content;;
									});
								 }
							});
						});
					}
			});
		} else {
			HoTransferService.query({
				uri : 'getAllStock'
			}).$promise.then(function(result){
				if (result) {
						transferCtr.transferRequestDTO={stockRequestLst:result,createdDate:paramCreatedDate
						,status:paramStatus,stockTransferId:transferCtr.getItemStockIdArray(result,parseInt(paramStockTransfer)),stockTransferLst:result,
						stockRequestId:transferCtr.getItemStockIdArray(result,parseInt(paramStockRequest)),stockTransferCode:paramStockTransferCode,
						page:1,size:5,sorting:'stock_transfer_code: "asc"'};
						transferCtr.createFlag = false;
						transferCtr.approveFlag = true;
						HoTransferService.query({
								uri : 'getAllStatusApprove'
							}, function(result) {
								transferCtr.statusLst = result;
								transferCtr.tableParams = new NgTableParams({
									page: 1, // show first page
									count : 5,
									sorting: { 'stock_transfer_code': 'asc' } 
								// count per page
								}, {
//									filterDelay : 300,
//									total: transferAll[0].totalCount,
									total: 0,
									defaultSort: 'asc',
									getData: function(params) {   
							    		var param = {};
							    		transferCtr.transferRequestDTO.page = params.page();
							    		transferCtr.transferRequestDTO.size = params.count();
							    		transferCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
							    		return HoTransferService.postPage({
											uri : 'getAllRequestApprove'
										},transferCtr.transferRequestDTO).$promise.then(function(result) {
							    			params.total(result.totalElements);
							    			transferCtr.lengthSearch = result.totalElements;
											return result.content;;
										});
							        }
						       });
					    });
				}
			});
		}
		transferCtr.transferReport = function() {
			if (param.typeMenu ==  transferCtr.CONST_EXPORTS.CREATE_STATUS_VIEW) {
				$scope.loading=true;
				HoTransferService.download({uri:'ho-transfer-report'}, transferCtr.transferRequestDTO,function(result) {
		        		$scope.loading=false;
		        }, function(error){
						$scope.loading=false;
		    	});	
			}else{
				$scope.loading=true;
				HoTransferService.download({uri:'ho-transfer-approve-report'}, transferCtr.transferRequestDTO,function(result) {
		        		$scope.loading=false;
		        }, function(error){
						$scope.loading=false;
		    	});	
			}
        }
		transferCtr.viewInfo = function(idx) {
			var typeProcess = transferCtr.CONST_EXPORTS.VIEW_STATUS_CODE;
			paramSearch=transferCtr.CONST_EXPORTS.VALUE_NULL;
			if(transferCtr.transferRequestDTO.stockRequestId!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
				}else{
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
				}
			}
			if(transferCtr.transferRequestDTO.stockTransferId!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
				}else{
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
				}			
			}
			if(transferCtr.transferRequestDTO.createdDate!='Invalid Date'){
				if(paramSearch!=''){
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
				}else{
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
				}
			}
			if(transferCtr.transferRequestDTO.status!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
				}else{
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
				}
			}
			if(transferCtr.transferRequestDTO.stockTransferCode!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
				}else{
					paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
				}
			}
			window.location.href = GLOBAL_URL
					+ transferCtr.CONST_EXPORTS.URL_HOTRANSFER
					+ '/'
					+ transferCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
					+ '/'
					+ $base64.encode(typeProcess)
					+ '/'
					+ $base64.encode(paramSearch)
					+ '/'
					+ $base64.encode(transferCtr.tableParams.data[idx].stockTransferCode);
			
		}
		transferCtr.editInfo = function(idx) {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = transferCtr.CONST_EXPORTS.MODIFY_STATUS_CODE;
					paramSearch=transferCtr.CONST_EXPORTS.VALUE_NULL;
					if(transferCtr.transferRequestDTO.stockRequestId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}			
					}
					if(transferCtr.transferRequestDTO.createdDate!='Invalid Date'){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}
					}
					if(transferCtr.transferRequestDTO.status!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferCode!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
							+ transferCtr.CONST_EXPORTS.URL_HOTRANSFER
							+ '/'
							+ transferCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
							+ '/'
							+ $base64.encode(typeProcess)
							+ '/'
							+ $base64.encode(paramSearch)
							+ '/'
							+ $base64.encode(transferCtr.tableParams.data[idx].stockTransferCode);
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
			
		}
		transferCtr.approveInfo = function(idx) {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = transferCtr.CONST_EXPORTS.APPROVE_STATUS_CODE;
					paramSearch=transferCtr.CONST_EXPORTS.VALUE_NULL;
					if(transferCtr.transferRequestDTO.stockRequestId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}			
					}
					if(transferCtr.transferRequestDTO.createdDate!='Invalid Date'){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}
					}
					if(transferCtr.transferRequestDTO.status!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferCode!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
							+ transferCtr.CONST_EXPORTS.URL_HOTRANSFER
							+ '/'
							+ transferCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
							+ '/'
							+ $base64.encode(typeProcess)
							+ '/'
							+ $base64.encode(paramSearch)
							+ '/'
							+ $base64.encode(transferCtr.tableParams.data[idx].stockTransferCode);
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
			
		}
		transferCtr.openCreate = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess= transferCtr.CONST_EXPORTS.CREATE_STATUS_CODE;
					paramSearch=transferCtr.CONST_EXPORTS.VALUE_NULL;
					if(transferCtr.transferRequestDTO.stockRequestId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockRequestId;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferId;
						}			
					}
					if(transferCtr.transferRequestDTO.createdDate!='Invalid Date'){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.createdDate;
						}
					}
					if(transferCtr.transferRequestDTO.status!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STATUS+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.status;
						}
					}
					if(transferCtr.transferRequestDTO.stockTransferCode!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}else{
							paramSearch=paramSearch+transferCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferCtr.CONST_EXPORTS.SIGN_COLON+transferCtr.transferRequestDTO.stockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL 
							+ transferCtr.CONST_EXPORTS.URL_HOTRANSFER
							+ '/'
							+ transferCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
							+ '/' 
							+ $base64.encode(typeProcess)
							+ '/'
							+ $base64.encode(paramSearch);
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		};
		transferCtr.dod = new Date();
		transferCtr.openDod = function() {
			transferCtr.popupDod.opened = true;
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		transferCtr.popupDod = {
			opened : false
		};

	}

})();
